import { orderMoviexkPay } from "@api/movie"
import dialog from "@utils/dialog";
import { pay } from "@libs/wechat";

// 支付
export function payMovieOrderHandle(orderId, type, from,tradeno, coupon_id) {
    return new Promise((resolve, reject) => {
      dialog.loading.open("支付中");
      orderMoviexkPay(orderId, type, from,tradeno, coupon_id)
        .then(res => {
          const data = res.data;
          dialog.loading.close();
          switch (data.status) {
            case "WECHAT_H5_PAY":
              reject(data);
              setTimeout(() => {
                location.replace(data.result.jsConfig.mweb_url);
              }, 100);
              break;
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_ERROR":
            case "PAY_DEFICIENCY":
              dialog.toast({ mes: res.msg });
              reject(data);
              break;
            case "SUCCESS":
              dialog.success(res.msg);
              resolve(data);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).then(() => {
                resolve(data);
              });
          }
        })
        .catch(err => {
          dialog.loading.close();
          dialog.toast({ mes: err.msg || "支付失败" });
        });
    });
  }